<template>
    <v-app>
        <Section301List/>
    </v-app>
</template>
<script>
import Section301List from './components/Section301List';

export default {
    name: 'App',
    components: {
        Section301List,
    },
}
</script>
<style>
.theme--dark.v-application {
    background-color: #17171D !important;
}
</style>